import React from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { ImageViewer } from "./ImageViewer";

export const ViewerImageOld = ({ show, handleClose, data }) => {
  return (
    <Modal show={show} onHide={handleClose}>
      <Modal.Header closeButton>
        <Modal.Title>Preview</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {" "}
        <ImageViewer url={data} />
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
